import React, { useEffect, useState } from 'react';

import IframeContainer from '../components/IframeContainer';
import { getPillarURL } from '../services/pillarUrlService';

function Pillar() {
    const [pillarUrl, setPillarUrl] = useState('');

    useEffect(() => {
        async function fetchURL() {
            try {
                const url = await getPillarURL();
                setPillarUrl(url);
            } catch (error) {
                console.error('Error fetching the Pillar URL:', error);
            }
        }
        fetchURL();
    }, []);

    return (
        <>
            <IframeContainer
                appName="Pillar"
                src={pillarUrl || 'about:blank'}
                title="Pillar"
            ></IframeContainer>
        </>
    );
}

export default Pillar;
